// extracted by mini-css-extract-plugin
module.exports = {"container":"e_xA","widget":"e_yA","title":"e_zA","msrp":"e_AA","separator":"e_BA","textBadge":"e_CA"};